/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SimNprogressDefaultOptions as ɵa} from './nprogress-config';